import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

const SIZE_CLASSES = {
  default: 'px-4 py-3 pr-12 text-foreground',
  sm: 'px-3 py-2 pr-10 text-sm text-foreground'
};

const ICON_SIZE_CLASSES = {
  default: 'right-4 h-5 w-5',
  sm: 'right-3 h-4 w-4'
};

const Select = React.forwardRef(function Select(
  { className, size = 'default', iconClassName, iconTestId, children, ...props },
  ref
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'w-full appearance-none bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent disabled:opacity-50',
          SIZE_CLASSES[size] || SIZE_CLASSES.default,
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        data-testid={iconTestId}
        aria-hidden="true"
        className={cn(
          'pointer-events-none absolute top-1/2 -translate-y-1/2 text-muted-foreground',
          ICON_SIZE_CLASSES[size] || ICON_SIZE_CLASSES.default,
          iconClassName
        )}
      />
    </div>
  );
});

export default Select;
